import React from 'react';

import LookupsHelper from 'lib/LookupsHelper';
import { I18n as I } from 'react-redux-i18n';

import bronzeMembership from 'static/img/Bronze.png';
import silverMembership from 'static/img/Silver.png';
import goldMembership from 'static/img/Gold.png';
import platinumMembership from 'static/img/Platinum.png';
import trialMembership from 'static/img/Trial.png';

import { Descriptions, Row, Col, List, Divider } from 'antd';

import {
  PhoneOutlined,
  MobileOutlined,
  PrinterOutlined,
  MailOutlined,
} from '@ant-design/icons';

const descriptionDetailsStyle = {
  fontSize: 16,
  fontWeight: 600,
};

const iconStyle = {
  marginLeft: 8,
  marginTop: 3,
};

const spanIconStyle = {
  display: 'flex',
  alignContent: 'center',
  // justifyContent: 'center',
};

const imageStyle = {
  height: '64px',
  width: '64px',
  textAlign: 'center',
};

const membershipObjects = [
  { ID: 1, Title: 'Bronze', Image: bronzeMembership, Message: 'Bronze' },
  { ID: 2, Title: 'Silver', Image: silverMembership, Message: 'Silver' },
  { ID: 3, Title: 'Gold', Image: goldMembership, Message: 'Golden' },
  { ID: 4, Title: 'Platinum', Image: platinumMembership, Message: 'Platinum' },
  { ID: 99, Title: 'Trial', Image: trialMembership, Message: 'Trial' },
];

const InsuranceMerchantDetails = ({
  applications,
  countries,
  party,
  partyAppMemberships,
  regions,
  taxOffices,
  user,
  isMerchant,
}) => {
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} xl={17}>
        <Row gutter={[10, 10]}>
          <Col className="profile">
            <Descriptions
              className="profile"
              colon={false}
              column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
              size="small"
              bordered
            >
              <Descriptions.Item label="Username">
                <span style={descriptionDetailsStyle}>
                  {party && party.Email}
                </span>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
        <Row gutter={[10, 10]}>
          <Col className="profile">
            <Descriptions
              className="profile"
              colon={false}
              column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
              size="small"
              bordered
            >
              <Descriptions.Item label={I.t('TITLE')}>
                <span style={descriptionDetailsStyle}>
                  {party && party.Title}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label={I.t('DISTINCTIVE_TITLE')}>
                <span style={descriptionDetailsStyle}>
                  {party && party.DistinctiveTitle}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label={I.t('TAXNUMBER')}>
                <span style={descriptionDetailsStyle}>
                  {party && party.AFM}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label={I.t('TAXOFFICE')}>
                <span style={descriptionDetailsStyle}>
                  {party &&
                    LookupsHelper.getDescription(taxOffices, party.TaxOfficeID)}
                </span>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
        <Row gutter={[10, 10]}>
          <Col className="profile">
            <Descriptions
              className="profile"
              colon={false}
              column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
              size="small"
              bordered
            >
              <Descriptions.Item
                label={
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <span>{I.t('PHONE')}</span>
                    <span style={spanIconStyle}>
                      <PhoneOutlined style={iconStyle} />
                    </span>
                  </div>
                }
              >
                <span style={descriptionDetailsStyle}>
                  {party && party.Phone}
                </span>
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <span>{I.t('FAX')}</span>
                    <span style={spanIconStyle}>
                      {' '}
                      <PrinterOutlined style={iconStyle} />
                    </span>
                  </div>
                }
              >
                <span style={descriptionDetailsStyle}>
                  {party && party.Fax}
                </span>
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <span>{I.t('MOBILE')}</span>
                    <span style={spanIconStyle}>
                      <MobileOutlined style={iconStyle} />
                    </span>
                  </div>
                }
              >
                <span style={descriptionDetailsStyle}>
                  {party && party.Mobile}
                </span>
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <span>{I.t('EMAIL')}</span>
                    <span style={spanIconStyle}>
                      <MailOutlined style={iconStyle} />
                    </span>
                  </div>
                }
              >
                <span style={descriptionDetailsStyle}>
                  {party && party.Email}
                </span>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
        <Row gutter={[10, 10]}>
          <Col className="profile">
            <Descriptions
              className="profile"
              colon={false}
              column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
              size="small"
              bordered
            >
              <Descriptions.Item label={I.t('CITY')}>
                <span style={descriptionDetailsStyle}>
                  {party && party.City}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label={I.t('STREET')}>
                <span style={descriptionDetailsStyle}>
                  {party && party.Street}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label={I.t('NUMBER')}>
                <span style={descriptionDetailsStyle}>
                  {party && party.StreetNumber}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label={I.t('POSTALCODE')}>
                <span style={descriptionDetailsStyle}>
                  {party && party.PostalCode}
                </span>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
        <Row gutter={[10, 10]}>
          <Col className="profile">
            <Descriptions
              className="profile"
              colon={false}
              column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
              size="small"
              bordered
            >
              <Descriptions.Item label={I.t('REGION')}>
                <span style={descriptionDetailsStyle}>
                  {party &&
                    LookupsHelper.getDescription(regions, party.RegionID)}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label={I.t('COUNTRY')}>
                <span style={descriptionDetailsStyle}>
                  {party &&
                    LookupsHelper.getDescription(countries, party.CountryID)}
                </span>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
      </Col>
      <Col xs={24} xl={7}>
        {isMerchant && partyAppMemberships && partyAppMemberships.length > 0 ? (
          <List
            itemLayout="vertical"
            dataSource={partyAppMemberships}
            header={
              <span style={descriptionDetailsStyle}>
                Applications - Memberships
              </span>
            }
            renderItem={item => (
              <List.Item
                key={item.ApplicationID}
                extra={
                  <img
                    style={imageStyle}
                    src={
                      membershipObjects.find(x => x.ID === item.MembershipID)
                        .Image
                    }
                    alt=""
                  />
                }
              >
                <List.Item.Meta
                  title={
                    <span style={descriptionDetailsStyle}>
                      {I.t(
                        LookupsHelper.getDescription(
                          applications,
                          item.ApplicationID || 0
                        )
                      )}
                    </span>
                  }
                  description={`${
                    membershipObjects.find(x => x.ID === item.MembershipID)
                      .Message
                  } Membership`}
                />
              </List.Item>
            )}
          />
        ) : null}
      </Col>
    </Row>
  );
};

export default InsuranceMerchantDetails;
